import * as React from "react"

const getDisplayName = (type: unknown): string | undefined => {
  if (!type || typeof type !== "function" && typeof type !== "object") {
    return undefined
  }

  return (type as { displayName?: string; name?: string }).displayName ||
    (type as { displayName?: string; name?: string }).name
}

export const containsDisplayName = (
  children: React.ReactNode,
  displayNames: string[]
): boolean =>
  React.Children.toArray(children).some((child) => {
    if (!React.isValidElement(child)) {
      return false
    }

    const displayName = getDisplayName(child.type)
    if (displayName && displayNames.includes(displayName)) {
      return true
    }

    return containsDisplayName(
      (child.props as { children?: React.ReactNode }).children,
      displayNames
    )
  })
